import { z } from 'zod';

export const formSchema = z.object({
  unit_id: z.string().min(1, 'Đơn vị là bắt buộc'),
  status: z.string().optional()
});

export type FormValues = z.infer<typeof formSchema>;

export const initialValues: FormValues = {
  unit_id: '',
  status: '1'
};
